import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import MapSection from './components/MapSection';
import ParkingSection from './components/ParkingSection';
import CTASection from '../home/components/CTASection';
import { updatePageSEO } from '../../utils/seo';

const AccessPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    updatePageSEO({
      title: 'アクセス | おかやま整形外科 - 岡山市北区の整形外科クリニック',
      description: 'おかやま整形外科へのアクセス方法。岡山市北区○○町1-2-3。JR岡山駅から徒歩10分。駐車場完備。バスでのアクセスも便利です。診療時間：月〜土 9:00-18:00。お気軽にお越しください。',
      keywords: 'アクセス, 地図, 駐車場, 岡山市北区, おかやま整形外科, 交通アクセス',
      canonical: `${siteUrl}/access`,
      structuredData: {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'アクセス',
        description: 'おかやま整形外科へのアクセス方法、地図、駐車場のご案内',
        url: `${siteUrl}/access`,
        breadcrumb: {
          '@type': 'BreadcrumbList',
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: 'ホーム',
              item: `${siteUrl}/`
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: 'アクセス',
              item: `${siteUrl}/access`
            }
          ]
        }
      }
    });
  }, []);

  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      <main>
        <HeroSection />
        <MapSection />
        <ParkingSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default AccessPage;
